import Button from './src/button';

export default Button;



// WEBPACK FOOTER //
// ./packages/button/index.js